import {
  FETCH_PURCHASE_RETURN,
  RESET_PURCHASE_RETURN,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const purchaseReturnViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PURCHASE_RETURN:
      return { data: action.payload };
    case RESET_PURCHASE_RETURN:
      return initialState;
    default:
      return state;
  }
};

export default purchaseReturnViewReducer;
